import React from "react";
import { useAuth } from "../context/auth";
import Home from "../pages/home";

function Logout(props) {
	const { setAuthTokens } = useAuth();
	setAuthTokens(); 	
	localStorage.clear(); 
	sessionStorage.clear(); 
	window.location.reload()	
	window.location.href='/'	
	return false
}

export default Logout;